/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import * as React from "react";
import { cn } from "../../utils/helpers";

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    labelClass?: string;
    name?: string;
    id?: string;
    inputSize?: "small" | "medium" | "large";
}

const sizeStyles = {
    small: {
        box: "size-12",
        overlay: "size-12 border-[3px]",
        icon: "size-8",
    },
    medium: {
        box: "size-16",
        overlay: "size-16 border-[4px]",
        icon: "size-12",
    },
    large: {
        box: "size-24",
        overlay: "size-24 border-[6px]",
        icon: "size-20",
    },
};

const FormCheckbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
    ({ label, labelClass, id, name, inputSize = "medium", ...props }, ref) => {
        const s = sizeStyles[inputSize];
        return (
            <div>
                <label
                    role="button"
                    tabIndex={0}
                    htmlFor={id}
                    className="relative flex items-center text-text text-base cursor-default checked:bg-primary checked:border-0"
                >
                    <input
                        className={cn(
                            "peer shrink-0 appearance-none bg-white [border:1px_solid_var(--color-stroke)] rounded-md cursor-default",
                            s.box
                        )}
                        type="checkbox"
                        id={id}
                        name={name}
                        ref={ref}
                        {...props}
                    />
                    <span
                        className={cn(
                            "absolute hidden rounded-md peer-checked:border-primary peer-checked:flex peer-checked:items-center peer-checked:justify-center peer-checked:bg-primary peer-indeterminate:*:hidden peer-indeterminate:flex peer-indeterminate:items-center peer-indeterminate:justify-center peer-indeterminate:border-primary peer-indeterminate:after:content-[''] peer-indeterminate:after:w-4/5 peer-indeterminate:after:h-[1.75px] peer-indeterminate:after:bg-stroke",
                            s.overlay
                        )}
                    >
                        <svg
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            stroke="currentColor"
                            strokeWidth="2"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className={cn("stroke-white", s.icon)}
                        >
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                    </span>
                    {label && (
                        <span className={cn(labelClass, "ml-3 font-medium")}>
                            {label}
                        </span>
                    )}
                </label>
            </div>
        );
    }
);

FormCheckbox.displayName = "FormCheckbox";

export { FormCheckbox };
